import {
  LuHeart as Heart,
  LuLaugh as Laugh,
  LuZap as Zap,
  LuFrown as Frown,
  LuThumbsUp as ThumbsUp,
  LuGlobe as Globe,
  LuUsers as Users,
  LuUser as User,
  LuActivity as Activity,
  LuBrain as Brain,
  LuMessageSquare as MessageSquare,
} from "react-icons/lu";
import { Post } from "../types/post.type";

export const getVibeIcon = (type: string) => {
  const iconClass = "h-4 w-4 transition-transform group-hover:scale-110";
  switch (type) {
    case "LOVE":
      return <Heart className={`${iconClass} text-red-500`} />;
    case "HAHA":
      return <Laugh className={`${iconClass} text-yellow-500`} />;
    case "WOW":
      return <Zap className={`${iconClass} text-blue-500`} />;
    case "SAD":
      return <Frown className={`${iconClass} text-gray-500`} />;
    case "NICE":
      return <ThumbsUp className={`${iconClass} text-green-500`} />;
    default:
      return null;
  }
};

export const getPostTypeIcon = (type: Post["type"]) => {
  const iconClass = "h-4 w-4";
  switch (type) {
    case "ACTIVITY":
      return <Activity className={iconClass} />;
    case "DUO_THOUGHT":
      return <Brain className={iconClass} />;
    case "POST":
      return <MessageSquare className={iconClass} />;
    default:
      return <MessageSquare className={iconClass} />;
  }
};

export const getVisibilityIcon = (visibility: Post["visibility"]) => {
  const iconClass = "h-3.5 w-3.5";
  switch (visibility) {
    case "PUBLIC":
      return <Globe className={iconClass} />;
    case "FOLLOWINGS":
      return <Users className={iconClass} />;
    default:
      return <User className={iconClass} />;
  }
};

// Enhanced Badge Colors with gradients and better contrast
export const getUserRoleBadgeClasses = (role: Post["role"]): string => {
  switch (role) {
    case "COACH":
      return "bg-gradient-to-r from-blue-50 to-blue-100 text-blue-700 border border-blue-200 shadow-sm";
    case "LEARNER":
      return "bg-gradient-to-r from-emerald-50 to-emerald-100 text-emerald-700 border border-emerald-200 shadow-sm";
    default:
      return "bg-gradient-to-r from-gray-50 to-gray-100 text-gray-700 border border-gray-200 shadow-sm";
  }
};

export const getPostTypeBadgeClasses = (type: Post["type"]): string => {
  switch (type) {
    case "ACTIVITY":
      return "bg-gradient-to-r from-purple-50 to-purple-100 text-purple-700 border border-purple-200 shadow-sm";
    case "DUO_THOUGHT":
      return "bg-gradient-to-r from-amber-50 to-amber-100 text-amber-700 border border-amber-200 shadow-sm";
    case "POST":
      return "bg-gradient-to-r from-green-50 to-green-100 text-green-700 border border-green-200 shadow-sm";
    default:
      return "bg-gradient-to-r from-gray-50 to-gray-100 text-gray-700 border border-gray-200 shadow-sm";
  }
};

export const getVisibilityBadgeClasses = (visibility: Post["visibility"]): string => {
  switch (visibility) {
    case "PUBLIC":
      return "bg-gradient-to-r from-rose-50 to-rose-100 text-rose-700 border border-rose-200 shadow-sm";
    case "FOLLOWINGS":
      return "bg-gradient-to-r from-indigo-50 to-indigo-100 text-indigo-700 border border-indigo-200 shadow-sm";
    default:
      return "bg-gradient-to-r from-gray-50 to-gray-100 text-gray-700 border border-gray-200 shadow-sm";
  }
};
